import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { Modal, Button } from 'web/src/app/root/components/common'

const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    pageTitle: {
        marginBottom: 40
    },
    btnsWrapper: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'flex-end'
    }
}))

export const LocationConfirmThresholdResetModal = ({
    onClose,
    open,
    onConfirmClick
}) => {
    const locale = useSelector(state => state.main.locale)
    const theme = useSelector(state => state.main.theme)
    const classes = useStyles(theme)

    const onConfirm = () => {
        onConfirmClick()
        onClose()
    }

    return (
        <Modal size="md" onClose={onClose} open={open} className={classes.root}>
            <div>{locale.locations.lBasedConfirmThresholdResetQuestion}</div>
            <div className={classes.btnsWrapper}>
                <Button style={{ marginRight: 8 }} onClick={onConfirm}>
                    {locale.common.confirm}
                </Button>
                <Button reverted onClick={onClose}>
                    {locale.common.cancel}
                </Button>
            </div>
        </Modal>
    )
}
